import { Outlet, useParams } from "react-router-dom";
import LoggedInLayout from "../../layouts/loggedin-layout";
import { Col, Row } from "react-bootstrap";
import ClientInformationNew from "../../components/clientinformationnew";
import ClientApplications from "../../components/clientapplications";

const ClientLandingPageNew = () => {
    const {medicaidid} = useParams();
    return(
        <LoggedInLayout>
            <div style={{padding: '25px'}}>
                <Row>
                    <Col xs={12} lg={3}>
                        <ClientInformationNew 
                            MedcaidId={medicaidid}
                        />
                    </Col>
                    <Col xs={12} lg={9}>
                        <Outlet context={{MedicaidID: medicaidid}}/>
                    </Col>
                </Row>
            </div>
        </LoggedInLayout>
    )
}

export default ClientLandingPageNew;